<!--
   全局自定义组件，传入iconFileName 对应静态资源中svg文件夹下的名称
-->
<template>
  <i v-if="iconFileName.indexOf('el-icon-') === 0" :class="iconFileName"/>
  <svg v-else :class="`svg-icon ${iconClass}`" aria-hidden="true" v-on="$listeners">
    <use :xlink:href="`#icon-${iconFileName}`" rel="external nofollow"/>
  </svg>
</template>

<script>
export default {
  name: 'svgIcon',
  props: {
    iconFileName: {
      type: String,
      required: true
    },
    iconClass: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  overflow: hidden;
  vertical-align: -0.25em;
  fill: currentColor;
}
</style>


// WEBPACK FOOTER //
// src/components/todoCenter/svgIcon.vue